export class spTicket_List_Selected {
    public constructor(init?: Partial<spTicket_List_Selected>) {Object.assign(this, init);}
    account_number: string;
    applied_amount: number;
    attorney_name: string;
    calendar_code: string;
    calendar_code_name: string;
    calendar_datetime: Date;
    case_id: string;
    case_number: string;
    case_sort: number;
    charge_schedule_id: string;
    close_date: Date;
    collection_payment_plan: boolean;
    collection_ticket_event_type_status: string;
    comment: string;
    default_judgment_id: string;
    default_judgment_number: string;
    default_judgment_reference: string;
    defendant_company: string;
    defendant_first_name: string;
    defendant_id: string;
    defendant_last_name: string;
    disposition_code: string;
    disposition_date: Date;
    disposition_name: string;
    docket_number: string;
    entry_datetime: Date;
    folder_number: string;
    grouping: string;
    grouping_description: string;
    grouping_name: string;
    in_collection: boolean;
    is_must_appear: boolean;
    is_primary: boolean;
    is_scoffed: boolean;
    judge_code: string;
    judge_name: string;
    license_number: string;
    license_state: string;
    minimum_payment_plan_amount: number;
    offense_datetime: Date;
    offer_rejected_accepted: string;
    open_balance: number;
    payment_amount: number;
    payment_due_date: Date;
    pb_eligible: boolean;
    pbm_acceptance_due_date: Date;
    pbm_id: string;
    pbm_mode_code: string;
    pbm_mode_name: string;
    pbm_mode_sort_order: number;
    pbm_offer_made_date: Date;
    pbm_receipt_date: Date;
    pbm_type_code: string;
    pbm_type_long_name: string;
    plate_id: string;
    plate_number: string;
    plate_state: string;
    plea_code: string;
    plea_date: Date;
    plea_name: string;
    receipt_date: Date;
    receipt_number: string;
    recorded_date: Date;
    related_ticket_count: number;
    selected_to_pay: boolean;
    session_id: string;
    statement_number: string;
    suspend_payment_due_date: boolean;
    ticket_amount: number;
    ticket_balance: number;
    ticket_id: string;
    ticket_number: string;
    ticket_paid: number;
    ticket_session_id: string;
    ticket_state_code: string;
    ticket_state_name: string;
    ticket_status_code: string;
    ticket_status_name: string;
    ticket_type: string;
    ticket_type_sort_order: number;
    violation_code: string;
    violation_code_description: string;
    violation_code_description_original: string;
    violation_code_original: string;
    violation_information: string;
    violation_location: string;
    violation_resolving: string;
}

